module.exports = __webpack_public_path__ + "img/message.e7f2498c.svg";